import { Tip } from '@/components/common/tip/Tip.tsx'
import React, { ReactNode } from 'react'
import { cn } from '@/lib/utils.ts'

export type PropsT = {
  children: ReactNode
  content?: string | React.ReactNode
  showTip: boolean
  className?: string
}

export default function PropertyPopoverTriggerTipWrapper({
  showTip,
  children,
  content,
  className,
}: PropsT) {
  if (!showTip) return <>{children}</>
  return (
    <Tip
      className={cn(`cursor-not-allowed`, className)}
      contentClassName={'max-w-full w-[calc(var(--sidebar-width)-32px)] '}
      side={'bottom'}
      defaultContent={!content}
      content={content}
    >
      {children}
    </Tip>
  )
}
